<div id="shared-label-multi-select-wrapper" class="multi-select-wrapper">
  <app-text id="shared-label-multi-select-heading" [textStyleType]="labelTextType">
    {{ labelText }}
  </app-text>
  <app-multi-select
    id="shared-label-multi-select-dropdown"
    [data]="data"
    [selectedItemList]="selectedItemList"
    [isDisabled]="isDisabled"
    (multiSelectChangeHandler)="onSelectionChange($event)"
  ></app-multi-select>
</div>
